<template>

    <app-layout>
    <!-- Hero Start -->
    <section class="bg-half-260 bg-primary d-table w-100" style="background-image: url('/assets/images/course/detail.png');">
        <div class="container">
            <div class="row mt-5 justify-content-center">
                <div class="col-lg-12 text-center">
                    <div class="pages-heading">

<!--                        <span class="badge text-bg-success h6 rounded-pill">-->
<!--                            $79-->
<!--                            full course-->
<!--                        </span>-->

                        <h2 class="title text-white title-dark mt-3 mb-0">
                            {{ course?.name }}
                        </h2>

<!--                        <ul class="list-unstyled mt-3 mb-0">-->
<!--                            <li class="align-items-center justify-content-center list-inline-item mx-1">-->
<!--                                <img src="assets/images/client/05.jpg" class="avatar avatar-ex-small rounded-pill shadow" alt="">-->
<!--                                <a href="javascript:void(0)" class="text-white title-dark ms-1">Cristina Murphy</a>-->
<!--                            </li>-->
<!--                        </ul>-->
                    </div>
                </div>  <!--end col-->
            </div><!--end row-->

<!--            <ul class="list-unstyled mt-4 mb-0 position-middle-bottom">-->

<!--                <li class="align-items-center justify-content-center list-inline-item mx-2">-->
<!--                    <i class="uil uil-clock fs-5 text-white title-dark align-middle"></i>-->
<!--                    <span class="text-white-50 ms-1">10 Weeks</span>-->
<!--                </li>-->

<!--                <li class="align-items-center justify-content-center list-inline-item mx-2">-->
<!--                    <i class="uil uil-signal fs-5 text-white title-dark align-middle"></i>-->
<!--                    <span class="text-white-50 ms-1">All Levels</span>-->
<!--                </li>-->

<!--                <li class="align-items-center justify-content-center list-inline-item mx-2">-->
<!--                    <i class="uil uil-book-open fs-5 text-white title-dark align-middle"></i>-->
<!--                    <span class="text-white-50 ms-1">16 Lessons</span>-->
<!--                </li>-->

<!--                <li class="align-items-center justify-content-center list-inline-item mx-2">-->
<!--                    <i class="uil uil-cube fs-5 text-white title-dark align-middle"></i>-->
<!--                    <span class="text-white-50 ms-1">0 Quiz</span>-->
<!--                </li>-->

<!--                <li class="align-items-center justify-content-center list-inline-item mx-2">-->
<!--                    <i class="uil uil-book-reader fs-5 text-white title-dark align-middle"></i>-->
<!--                    <span class="text-white-50 ms-1">5 Students</span>-->
<!--                </li>-->

<!--                <li class="align-items-center justify-content-center list-inline-item mx-2"  v-if="course.type == 'paid'">-->
<!--                    <i class="uil uil-shopping-cart fs-5 text-white title-dark align-middle"></i>-->
<!--                    <a href="#Subscription" class="text-white">Buy Now</a>-->
<!--                </li>-->

<!--            </ul>-->
        </div> <!--end container-->
    </section><!--end section-->
    <!-- Hero End -->

    <!-- Shape Start -->
    <div class="position-relative">
        <div class="shape overflow-hidden text-color-white">
            <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
            </svg>
        </div>
    </div>
    <!--Shape End-->

    <!-- Start -->
    <section class="section">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="section-title">
                        <h4 class="title mb-4">Overview</h4>
                        <div v-html="course?.content"></div>
                    </div>

<!--                    <div class="row">-->
<!--                        <div class="col-md-6 mt-4 pt-2"><img src="assets/images/course/de01.jpg" class="img-fluid rounded shadow" alt=""></div>-->
<!--                        <div class="col-md-6 mt-4 pt-2">-->
<!--                            <div class="position-relative">-->
<!--                                <img src="assets/images/course/de02.jpg" class="rounded img-fluid mx-auto d-block" alt="">-->
<!--                                <div class="play-icon">-->
<!--                                    <a href="#!" data-type="youtube" data-id="yba7hPeTSjk" class="play-btn lightbox border-0">-->
<!--                                        <i class="mdi mdi-play text-primary rounded-circle shadow"></i>-->
<!--                                    </a>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>&lt;!&ndash;end col&ndash;&gt;-->
<!--                    </div>&lt;!&ndash;end row&ndash;&gt;-->

<!--                    <div class="section-title mt-4 pt-2">-->
<!--                        <h4 class="title mb-0">Curriculum</h4>-->

<!--                        <div class="row">-->
<!--                            <div class="col-md-6 mt-4 pt-2">-->
<!--                                <h5 class="mb-0">Introductions</h5>-->

<!--                                <div class="table-responsive bg-white shadow rounded mt-4">-->
<!--                                    <table class="table mb-0 table-center">-->
<!--                                        <thead>-->
<!--                                        <tr>-->
<!--                                            <th scope="col" class="fw-normal border-bottom text-muted py-4 px-3" style="min-width: 100px;">Lessons</th>-->
<!--                                            <th scope="col" class="fw-normal border-bottom text-muted py-4 px-3 text-end">Time</th>-->
<!--                                        </tr>-->
<!--                                        </thead>-->

<!--                                        <tbody>-->
<!--                                        <tr>-->
<!--                                            <th class="p-3">-->
<!--                                                <div class="align-items-center">-->
<!--                                                    <i class="uil uil-notes h6"></i>-->
<!--                                                    <p class="mb-0 d-inline fw-normal h6 ms-1"><a href="javascript:void(0)" class="text-muted">Lesson 1</a></p>-->
<!--                                                </div>-->
<!--                                            </th>-->
<!--                                            <td class="p-3 text-end"><span class="badge bg-soft-primary">Read Free</span></td>-->
<!--                                        </tr>-->
<!--                                        <tr>-->
<!--                                            <th class="p-3">-->
<!--                                                <div class="align-items-center">-->
<!--                                                    <i class="uil uil-notes h6"></i>-->
<!--                                                    <p class="mb-0 d-inline fw-normal h6 ms-1"><a href="javascript:void(0)" class="text-muted">Lesson 2</a></p>-->
<!--                                                </div>-->
<!--                                            </th>-->
<!--                                            <td class="p-3 text-end"><i class="uil uil-lock"></i></td>-->
<!--                                        </tr>-->
<!--                                        <tr>-->
<!--                                            <th class="p-3">-->
<!--                                                <div class="align-items-center">-->
<!--                                                    <i class="uil uil-notes h6"></i>-->
<!--                                                    <p class="mb-0 d-inline fw-normal h6 ms-1"><a href="javascript:void(0)" class="text-muted">Lesson 3</a></p>-->
<!--                                                </div>-->
<!--                                            </th>-->
<!--                                            <td class="p-3 text-end"><i class="uil uil-lock"></i></td>-->
<!--                                        </tr>-->
<!--                                        <tr>-->
<!--                                            <th class="p-3">-->
<!--                                                <div class="align-items-center">-->
<!--                                                    <i class="uil uil-notes h6"></i>-->
<!--                                                    <p class="mb-0 d-inline fw-normal h6 ms-1"><a href="javascript:void(0)" class="text-muted">Lesson 4</a></p>-->
<!--                                                </div>-->
<!--                                            </th>-->
<!--                                            <td class="p-3 text-end"><i class="uil uil-lock"></i></td>-->
<!--                                        </tr>-->
<!--                                        </tbody>-->
<!--                                    </table>-->
<!--                                </div>-->
<!--                            </div>&lt;!&ndash;end col&ndash;&gt;-->

<!--                            <div class="col-md-6 mt-4 pt-2">-->
<!--                                <h5 class="mb-0">Mastery</h5>-->

<!--                                <div class="table-responsive bg-white shadow rounded mt-4">-->
<!--                                    <table class="table mb-0 table-center">-->
<!--                                        <thead>-->
<!--                                        <tr>-->
<!--                                            <th scope="col" class="fw-normal border-bottom text-muted py-4 px-3" style="min-width: 100px;">Lessons</th>-->
<!--                                            <th scope="col" class="fw-normal border-bottom text-muted py-4 px-3 text-end">Time</th>-->
<!--                                        </tr>-->
<!--                                        </thead>-->

<!--                                        <tbody>-->
<!--                                        <tr>-->
<!--                                            <th class="p-3">-->
<!--                                                <div class="align-items-center">-->
<!--                                                    <i class="uil uil-notes h6"></i>-->
<!--                                                    <p class="mb-0 d-inline fw-normal h6 ms-1"><a href="javascript:void(0)" class="text-muted">Lesson 11</a></p>-->
<!--                                                </div>-->
<!--                                            </th>-->
<!--                                            <td class="p-3 text-end"><span class="badge bg-soft-primary">Read Free</span></td>-->
<!--                                        </tr>-->
<!--                                        <tr>-->
<!--                                            <th class="p-3">-->
<!--                                                <div class="align-items-center">-->
<!--                                                    <i class="uil uil-notes h6"></i>-->
<!--                                                    <p class="mb-0 d-inline fw-normal h6 ms-1"><a href="javascript:void(0)" class="text-muted">Lesson 12</a></p>-->
<!--                                                </div>-->
<!--                                            </th>-->
<!--                                            <td class="p-3 text-end"><i class="uil uil-lock"></i></td>-->
<!--                                        </tr>-->
<!--                                        <tr>-->
<!--                                            <th class="p-3">-->
<!--                                                <div class="align-items-center">-->
<!--                                                    <i class="uil uil-notes h6"></i>-->
<!--                                                    <p class="mb-0 d-inline fw-normal h6 ms-1"><a href="javascript:void(0)" class="text-muted">Lesson 13</a></p>-->
<!--                                                </div>-->
<!--                                            </th>-->
<!--                                            <td class="p-3 text-end"><i class="uil uil-lock"></i></td>-->
<!--                                        </tr>-->
<!--                                        <tr>-->
<!--                                            <th class="p-3">-->
<!--                                                <div class="align-items-center">-->
<!--                                                    <i class="uil uil-notes h6"></i>-->
<!--                                                    <p class="mb-0 d-inline fw-normal h6 ms-1"><a href="javascript:void(0)" class="text-muted">Lesson 14</a></p>-->
<!--                                                </div>-->
<!--                                            </th>-->
<!--                                            <td class="p-3 text-end"><i class="uil uil-lock"></i></td>-->
<!--                                        </tr>-->
<!--                                        </tbody>-->
<!--                                    </table>-->
<!--                                </div>-->
<!--                            </div>&lt;!&ndash;end col&ndash;&gt;-->

<!--                            <div class="col-md-6 mt-4 pt-2">-->
<!--                                <h5 class="mb-0">Final Thoughts</h5>-->

<!--                                <div class="table-responsive bg-white shadow rounded mt-4">-->
<!--                                    <table class="table mb-0 table-center">-->
<!--                                        <thead>-->
<!--                                        <tr>-->
<!--                                            <th scope="col" class="fw-normal border-bottom text-muted py-4 px-3" style="min-width: 100px;">Lessons</th>-->
<!--                                            <th scope="col" class="fw-normal border-bottom text-muted py-4 px-3 text-end">Time</th>-->
<!--                                        </tr>-->
<!--                                        </thead>-->

<!--                                        <tbody>-->
<!--                                        <tr>-->
<!--                                            <th class="p-3">-->
<!--                                                <div class="align-items-center">-->
<!--                                                    <i class="uil uil-notes h6"></i>-->
<!--                                                    <p class="mb-0 d-inline fw-normal h6 ms-1"><a href="javascript:void(0)" class="text-muted">Lesson 21</a></p>-->
<!--                                                </div>-->
<!--                                            </th>-->
<!--                                            <td class="p-3 text-end"><span class="badge bg-soft-primary">Read Free</span></td>-->
<!--                                        </tr>-->
<!--                                        <tr>-->
<!--                                            <th class="p-3">-->
<!--                                                <div class="align-items-center">-->
<!--                                                    <i class="uil uil-notes h6"></i>-->
<!--                                                    <p class="mb-0 d-inline fw-normal h6 ms-1"><a href="javascript:void(0)" class="text-muted">Lesson 22</a></p>-->
<!--                                                </div>-->
<!--                                            </th>-->
<!--                                            <td class="p-3 text-end"><i class="uil uil-lock"></i></td>-->
<!--                                        </tr>-->
<!--                                        <tr>-->
<!--                                            <th class="p-3">-->
<!--                                                <div class="align-items-center">-->
<!--                                                    <i class="uil uil-notes h6"></i>-->
<!--                                                    <p class="mb-0 d-inline fw-normal h6 ms-1"><a href="javascript:void(0)" class="text-muted">Lesson 23</a></p>-->
<!--                                                </div>-->
<!--                                            </th>-->
<!--                                            <td class="p-3 text-end"><i class="uil uil-lock"></i></td>-->
<!--                                        </tr>-->
<!--                                        <tr>-->
<!--                                            <th class="p-3">-->
<!--                                                <div class="align-items-center">-->
<!--                                                    <i class="uil uil-notes h6"></i>-->
<!--                                                    <p class="mb-0 d-inline fw-normal h6 ms-1"><a href="javascript:void(0)" class="text-muted">Lesson 24</a></p>-->
<!--                                                </div>-->
<!--                                            </th>-->
<!--                                            <td class="p-3 text-end"><i class="uil uil-lock"></i></td>-->
<!--                                        </tr>-->
<!--                                        </tbody>-->
<!--                                    </table>-->
<!--                                </div>-->
<!--                            </div>&lt;!&ndash;end col&ndash;&gt;-->

<!--                            <div class="col-md-6 mt-4 pt-2">-->
<!--                                <h5 class="mb-0">Bonus</h5>-->

<!--                                <div class="table-responsive bg-white shadow rounded mt-4">-->
<!--                                    <table class="table mb-0 table-center">-->
<!--                                        <thead>-->
<!--                                        <tr>-->
<!--                                            <th scope="col" class="fw-normal border-bottom text-muted py-4 px-3" style="min-width: 100px;">Lessons</th>-->
<!--                                            <th scope="col" class="fw-normal border-bottom text-muted py-4 px-3 text-end">Time</th>-->
<!--                                        </tr>-->
<!--                                        </thead>-->

<!--                                        <tbody>-->
<!--                                        <tr>-->
<!--                                            <th class="p-3">-->
<!--                                                <div class="align-items-center">-->
<!--                                                    <i class="uil uil-notes h6"></i>-->
<!--                                                    <p class="mb-0 d-inline fw-normal h6 ms-1"><a href="javascript:void(0)" class="text-muted">Lesson 31</a></p>-->
<!--                                                </div>-->
<!--                                            </th>-->
<!--                                            <td class="p-3 text-end"><span class="badge bg-soft-primary">Read Free</span></td>-->
<!--                                        </tr>-->
<!--                                        <tr>-->
<!--                                            <th class="p-3">-->
<!--                                                <div class="align-items-center">-->
<!--                                                    <i class="uil uil-notes h6"></i>-->
<!--                                                    <p class="mb-0 d-inline fw-normal h6 ms-1"><a href="javascript:void(0)" class="text-muted">Lesson 32</a></p>-->
<!--                                                </div>-->
<!--                                            </th>-->
<!--                                            <td class="p-3 text-end"><i class="uil uil-lock"></i></td>-->
<!--                                        </tr>-->
<!--                                        <tr>-->
<!--                                            <th class="p-3">-->
<!--                                                <div class="align-items-center">-->
<!--                                                    <i class="uil uil-notes h6"></i>-->
<!--                                                    <p class="mb-0 d-inline fw-normal h6 ms-1"><a href="javascript:void(0)" class="text-muted">Lesson 33</a></p>-->
<!--                                                </div>-->
<!--                                            </th>-->
<!--                                            <td class="p-3 text-end"><i class="uil uil-lock"></i></td>-->
<!--                                        </tr>-->
<!--                                        <tr>-->
<!--                                            <th class="p-3">-->
<!--                                                <div class="align-items-center">-->
<!--                                                    <i class="uil uil-notes h6"></i>-->
<!--                                                    <p class="mb-0 d-inline fw-normal h6 ms-1"><a href="javascript:void(0)" class="text-muted">Lesson 34</a></p>-->
<!--                                                </div>-->
<!--                                            </th>-->
<!--                                            <td class="p-3 text-end"><i class="uil uil-lock"></i></td>-->
<!--                                        </tr>-->
<!--                                        </tbody>-->
<!--                                    </table>-->
<!--                                </div>-->
<!--                            </div>&lt;!&ndash;end col&ndash;&gt;-->
<!--                        </div>&lt;!&ndash;end row&ndash;&gt;-->
<!--                    </div>-->

<!--                    <div class="section-title mt-4 pt-2">-->
<!--                        <h4 class="title mb-0">Instructor</h4>-->

<!--                        <div class="d-md-flex align-items-center mt-4 pt-2">-->
<!--                            <img src="assets/images/client/05.jpg" class="avatar avatar-medium rounded-pill" alt="">-->

<!--                            <div class="ms-md-3 mt-4 mt-sm-0">-->
<!--                                <a href="javascript:void(0)" class="text-dark h5">Cristina Murphy</a>-->
<!--                                <p class="text-muted mb-0 mt-2">I have started my career as a trainee and prove my self and achieve all the milestone with good guidance and reach up to the project manager. In this journey, I understand all the procedure which make me a good developer, team leader, and a project manager.</p>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
                </div><!--end col-->
            </div><!--end row-->
        </div><!--end container-->
    </section><!--end section-->
    <!-- End -->

    <!--    <section class="content py-4">-->
<!--        <nav aria-label="breadcrumb">-->
<!--            <ol class="breadcrumb">-->
<!--                                <li class="breadcrumb-item" aria-current="page"><router-link :to="{name: 'courses.index'}" class="nav-item nav-link">الكورسات</router-link></li>                <li class="breadcrumb-item active" aria-current="page">view</li>-->
<!--            </ol>-->
<!--        </nav>-->
<!--        <div class="card ">-->
<!--            <ul class="list-group list-group-flush">-->

<!--                <li class="list-group-item">-->
<!--                    <span class="badge bg-primary rounded-pill">الاسم</span>-->
<!--                                        -->
<!--                </li>-->
<!--                -->

<!--                <li class="list-group-item">-->
<!--                    <span class="badge bg-primary rounded-pill">النوع</span>-->
<!--                    {{ item?.type }}                    -->
<!--                </li>-->
<!--                -->

<!--                <li class="list-group-item">-->
<!--                    <span class="badge bg-primary rounded-pill">صورة</span>-->
<!--                    <a v-if="course.image" :href="course.image">{{ course.image }}</a>                    -->
<!--                </li>-->
<!--                -->

<!--                <li class="list-group-item">-->
<!--                    <span class="badge bg-primary rounded-pill">الوصف</span>-->
<!--                    {{ item?.description }}                    -->
<!--                </li>-->
<!--                -->

<!--                <li class="list-group-item">-->
<!--                    <span class="badge bg-primary rounded-pill">محتوى الصفحة التعريفى</span>-->
<!--                    {{ item?.content }}                    -->
<!--                </li>-->
<!--                -->

<!--            </ul>-->
<!--        </div>-->
<!--    </section>-->


    <!-- Price Start -->
    <section class="section pt-5" v-if="course.type == 'paid'" >
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12 text-center">
                    <div class="section-title mb-4 pb-2">
                        <h4 class="title mb-4">Subscription options</h4>
                        <p class="text-muted para-desc mx-auto mb-0">
                            You can view the entire content after subscribing.
                        </p>
                    </div>
                </div><!--end col-->
            </div><!--end row-->

            <div class="row align-items-center">
                <div class="col-12 mt-4 pt-2">
                    <div class="row d-flex justify-content-center">
                        <div class="col-lg-3 col-md-6 col-12 mt-4 pt-2" v-for="price in course?.prices ?? []">
                            <div class="card pricing pricing-primary bg-light rounded border-0">
                                <div class="card-body py-5">
                                    <h6 class="title text-uppercase fw-bold mb-4">
                                        Subscription for {{price?.subscription_duration ?? ''}}.
                                    </h6>
                                    <div class="d-flex mb-4">
                                        <span class="h4 mb-0 mt-2">JOD</span>
                                        <span class="price h1 mb-0">{{ price?.price ?? ''}} </span>
<!--                                        <span class="h4 align-self-end mb-1">/{{price?.subscription_duration ?? ''}} Day</span>-->
                                    </div>

                                    <ul class="list-unstyled mb-0 ps-0 mb-2">
                                        <li class="text-muted mb-0"><span class="text-primary h5 me-2"><i class="uil uil-check-circle align-middle"></i></span>View all content.</li>
                                        <li class="text-muted mb-0"><span class="text-primary h5 me-2"><i class="uil uil-check-circle align-middle"></i></span>Use all tests.</li>
                                        <li class="text-muted mb-0"><span class="text-primary h5 me-2"><i class="uil uil-check-circle align-middle"></i></span>Education level reports.</li>
                                        <li class="text-muted mb-0"><span class="text-primary h5 me-2"><i class="uil uil-check-circle align-middle"></i></span>Watch from anywhere.</li>
                                    </ul>
                                    <subscribe :course="course" :price="price"></subscribe>
<!--                                    <router-link :to="{'name' : 'subscriptions.create' , query : { 'course_id' : course.id , 'price_id' : price?.id }}" class="btn btn-primary mt-4">-->
<!--                                        Buy Now-->
<!--                                    </router-link>-->
                                </div>
                            </div>
                        </div><!--end col-->

                    </div><!--end row-->

                </div><!--end col-->
            </div><!--end row-->
        </div><!--end container-->
    </section><!--end section-->
    <section class="section pt-5" v-if="course.type == 'free'" >
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12 text-center">
                    <div class="section-title mb-4 pb-2">
                        <h4 class="title mb-4">Subscription options</h4>
                        <p class="text-muted para-desc mx-auto mb-0">
                            You can view the entire content after subscribing.
                        </p>
                    </div>
                </div><!--end col-->
            </div><!--end row-->

            <div class="row align-items-center">
                <div class="col-12 mt-4 pt-2">
                    <div class="row d-flex justify-content-center">
                        <div class="col-lg-3 col-md-6 col-12 mt-4 pt-2" >
                            <div class="card pricing pricing-primary bg-light rounded border-0">
                                <div class="card-body py-5">
                                    <h6 class="title text-uppercase fw-bold mb-4">
                                        it's free.
                                    </h6>
                                    <div class="d-flex mb-4">
                                        <span class="h4 mb-0 mt-2">JOD</span>
                                        <span class="price h1 mb-0">0.0</span>
<!--                                        <span class="h4 align-self-end mb-1">/{{price?.subscription_duration ?? ''}} Day</span>-->
                                    </div>

                                    <ul class="list-unstyled mb-0 ps-0 mb-2">
                                        <li class="text-muted mb-0"><span class="text-primary h5 me-2"><i class="uil uil-check-circle align-middle"></i></span>View all content.</li>
                                        <li class="text-muted mb-0"><span class="text-primary h5 me-2"><i class="uil uil-check-circle align-middle"></i></span>Use all tests.</li>
                                        <li class="text-muted mb-0"><span class="text-primary h5 me-2"><i class="uil uil-check-circle align-middle"></i></span>Education level reports.</li>
                                        <li class="text-muted mb-0"><span class="text-primary h5 me-2"><i class="uil uil-check-circle align-middle"></i></span>Watch from anywhere.</li>
                                    </ul>
                                    <subscribe :course="course" :price="null"></subscribe>
<!--                                    <router-link :to="{'name' : 'subscriptions.create' , query : { 'course_id' : course.id , 'price_id' : price?.id }}" class="btn btn-primary mt-4">-->
<!--                                        Buy Now-->
<!--                                    </router-link>-->
                                </div>
                            </div>
                        </div><!--end col-->

                    </div><!--end row-->

                </div><!--end col-->
            </div><!--end row-->
        </div><!--end container-->
    </section><!--end section-->
<!--    <div class="position-relative">-->
<!--        <div class="shape overflow-hidden text-light">-->
<!--            <svg viewBox="0 0 2880 250" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                <path d="M720 125L2160 0H2880V250H0V125H720Z" fill="currentColor"></path>-->
<!--            </svg>-->
<!--        </div>-->
<!--    </div>-->
    <!-- Price End -->
    </app-layout>
</template>

<script>
import { useToast } from "vue-toastification";
import AppLayout from "../../app-layout.vue";
import Subscribe from "../subscription/subscribe.vue";
import {useHead} from "@vueuse/head";
const toast = useToast();

export default {
    components: {Subscribe, AppLayout},
    data() {
        return {
            course: []
        }
    },
    created() {

        const id = toast.info('Getting content ...',{ icon: 'fa-solid fa-download' });

        axios.get(`courses/${this.$route.params.id}`, {}).then(response => {

            this.course = response.data.data;

            useHead({
                title: this.course?.name,
            })

            toast.dismiss(id);
        }, response => {
            toast.dismiss(id);
        });
    },
}
</script>
